import { Injectable } from '@angular/core';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { ProfileService } from '@services/profile/profile.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs';
import { JOURNAL_MODULE_NAME } from '../../../module';
import { FreetextToolService } from '../../freetext-tool/freetext-tool.service';
import { JournalToolsControllerService } from '../../journal-tools-controller/journal-tools-controller.service';

@AddinExecute({
  name: 'JournalToolsSetup'
})
@Injectable()
export class JournalToolsSetupService extends Execute {
  constructor(
    private profileService: ProfileService,
    private profileReader: ProfileReaderService,
    private freetextTool: FreetextToolService,
    private journalToolsController: JournalToolsControllerService
  ) {
    super();
  }

  execute() {
    this.profileService.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => this.onProfileReady());
  }

  private onProfileReady() {
    const toolsEnabled: boolean = this.profileReader.getComponentConfig(JOURNAL_MODULE_NAME, 'tools', false);
    if (toolsEnabled) {
      this.freetextTool.registerTool();
    }

    const canAddFreeTextStampTypes: number[] = this.profileReader.getComponentConfig(JOURNAL_MODULE_NAME, 'canAddFreeTextStampTypes', []);
    const fromMyCallcardOnly: boolean = this.profileReader.getComponentConfig(JOURNAL_MODULE_NAME, 'addFromMyCallcardOnly', true);
    this.journalToolsController.setup(canAddFreeTextStampTypes, fromMyCallcardOnly);
  }
}
